export enum LoginState {
  usernameInput = 'username_input',
  passwordInput = 'password_input',
  otpInput = 'otp_input',
  passwordRecovery = 'password_recovery',
  success = 'success',
}